<template>
    <div class="page myCoursePage">
        <!--<h3 class="page-title">{{$t('course.myCourse')}}</h3>-->

        <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="$t('course.name')">
                <el-input v-model="formSearch.name" :placeholder="$t('tip.name')"
                          @keyup.enter.native="queryMyCourse(1)" clearable></el-input>
            </el-form-item>
            <select-multiple :nameArrays="selectNames"
                             @getForLevelVal="getForLevelVal"
                             @getCourseTypeVal="getCourseTypeVal">
            </select-multiple>
            <select-multi-knowledge @knowledgeChange="knowledgeChange"></select-multi-knowledge>

            <el-form-item :label="$t('c.productionDate')">
                <el-date-picker
                    v-model="formSearch.afterDate "
                    type="date"
                    :placeholder="$t('tip.startTime')"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span>{{$t('c.to')}}</span>
                <el-date-picker
                    v-model="formSearch.beforeDate "
                    type="date"
                    :placeholder="$t('tip.endTime')"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryMyCourse(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>
        <div class="page-table">
            <div class="page-operate">
                <el-button-group>
                    <el-tooltip class="item" effect="dark" :content="$t('course.theoryCoursewareMake')" placement="top-start" :hide-after="1000">
                        <el-button size="small" @click="$router.push({name: 'theoryCourseAdd'})">
                            <i class="nucfont inuc-theory"></i>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('course.imageCoursewareMake')" placement="top" :hide-after="1000">
                        <el-button size="small" @click="$router.push({name: 'imageCourseAdd'})">
                            <i class="nucfont inuc-picture-add"></i>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip v-show="isDeleteShow" class="item" effect="dark" :content="$t('c.delete')" placement="top-end"
                                :hide-after="1000">
                        <el-button size="small" :title="$t('c.delete')" @click="deleteCourse">
                            <i class="nucfont inuc-delete"></i>
                        </el-button>
                    </el-tooltip>
                </el-button-group>
            </div>
            <data-tables class="form-table"
                         ref="courseTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         @selection-change="handleSelectionChange"
            >
                <!-- column checkbox -->
                <el-table-column
                    type="selection"
                    width="55px"
                    :reserve-selection="true"
                    align="center">
                </el-table-column>
                <!-- column title -->
                <el-table-column property="name" :label="$t('course.name')" align="center"
                                 min-width="190px" show-overflow-tooltip></el-table-column>
                <el-table-column property="typeName" :label="$t('course.type')" align="center" show-overflow-tooltip sortable>
                    <template slot-scope="scope">
                        <span class="type-bg" :class="typeBg(scope.row.type)">{{scope.row.typeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                 align="center"
                                 :width="title.width" :min-width="title.minWidth"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                </el-table-column>

                <el-table-column v-if="userInfo.type===1" prop="creatorName" :label="$t('c.producer')" align="center" show-overflow-tooltip sortable></el-table-column>

                <el-table-column :label="$t('c.operation')" align="center">
                    <div class="btn-cell" slot-scope="scope">

                        <i class="nucfont inuc-preview"
                           :title="$t('c.view')"
                           @click="previewCourse(scope.row)"></i>
                        <i class="nucfont inuc-edit"
                           :title="$t('c.edit')"
                           @click="editCourse(scope.row.id,scope.row.type)"></i>
                    </div>
                </el-table-column>
            </data-tables>
        </div>
        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @needUpdate="queryMyCourse"></router-view>
        </transition>
        <course-preview :isShow="isPreviewCourse" :courseID="courseID" v-on:courseExit="courseIsExit" ref="theoryCourse"/>
        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />
    </div>
</template>

<script>
import api from '@/api';
import {mapGetters} from 'vuex'
import selectMultiKnowledge from '@/components/SelectMultiKnowledge';
import selectMultiple from '../../components/Selectmultiple.vue'
import FullScreen from '../../components/FullScreen.vue'
import CoursePreview from './CoursePreview.vue'
export default {
    data(){
        return {
            // CT,DR
            isShow: false,
            src: '',
            // thoery
            courseID: '0',
            isPreviewCourse: false,
            formSearch:{
                name:'',
                types: [],
                forLevels: [],
                afterDate : '',
                beforeDate : '',
                knowledges:[0],
                creator:''
            },
            selectNames: [
                {key: "courseType"}, {key: "forLevel"}],
            isDeleteShow: false,
            tableData:[],
            tableProps: {
                border: true,
                stripe: true,
                rowKey: row => row.id,
                height: "auto"
            },
            currentPage: 1,
            titles: [
//                {
//                    prop: 'name',
//                    label: this.$t('course.name'),
//                    minWidth: '190px'
//                }, {
//                    prop: 'typeName',
//                    label: this.$t('course.type')
//                },
                {
                    prop: 'forLevelName',
                    label: this.$t('c.operatorLevel')
                }, {
                    prop: 'knowledgeName',
                    label: this.$t('c.knowledgePoint')
                }, {
                    prop: 'hours',
                    label: this.$t('train.hour'),
                    sortable: 'custom'
                }, {
                    prop: 'score',
                    label: this.$t('train.credit'),
                    sortable: 'custom'
                }, {
                    prop: 'createTime',
                    label: this.$t('c.makingTime'),
                    sortable: 'custom'
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['userInfo',]),
        pickerOptions1() {
            let that = this;
            return {
                disabledDate(time) {
                    if (!that.formSearch.beforeDate ) return false;
                    return time.getTime() > new Date(that.formSearch.beforeDate ).getTime()
                },
            }
        },
        pickerOptions2() {
            let that = this;
            return {
                disabledDate(time) {
                    if (!that.formSearch.afterDate ) return false;
                    return time.getTime() < new Date(that.formSearch.afterDate ).getTime()
                },
            }
        },
    },
    created() {
        this.queryMyCourse()
    },
    beforeDestroy() {
        // 凡是有全屏显示的页面都需要在销毁前解除对resize的事件绑定
        $(window).off('resize')
    },
    methods:{
        queryMyCourse(type){
            if(type==1){
                this.currentPage = 1;
            }

            let queryData = {...this.formSearch};

            ['types', 'forLevels', 'knowledges'].forEach(v => {
                if (this.formSearch[v].includes(0)) {
                    delete queryData[v];
                }
            });

            this.$nextTick(() => {
                api.getMyCourse(queryData).then(res => {
                    let data = res.package;
                    data.forEach(item => {
                        item.createTime = item.createTime && item.createTime.split(' ')[0];
                    });
                    this.tableData = data;
                })
            })

        },
        //搜索赋值
        getCourseTypeVal(data){
            this.formSearch.types = data;
        },
        getForLevelVal(data){
            this.formSearch.forLevels = data;
        },
        knowledgeChange(data) {
            this.formSearch.knowledges = data;
        },
        //课件删除
        deleteCourse() {
            this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                type: 'warning'
            }).then(() => {
                if (this.selectIds.length === 1) {
                    api.deleteCourseSingle(this.selectIds).then(res => {
                        this.success(this.$t('m.delSuccess'));
                        this.isDeleteShow = false;
                        this.queryMyCourse();
                        this.$refs.courseTable.$refs.elTable.clearSelection();
                    });
                } else {
                    api.deleteCourseBatch({ids: this.selectIds}).then(res => {
                        this.success(this.$t('m.delSuccess'));
                        this.isDeleteShow = false;
                        this.queryMyCourse();
                        this.$refs.courseTable.$refs.elTable.clearSelection();
                    });
                }
            }).catch(()=>{});
        },
        handleSelectionChange(val) {
            this.selectIds = [];
            val.forEach(v => this.selectIds.push(v.id));
            this.isDeleteShow = this.selectIds.length > 0;
        },
        success(msg) {
            this.$message({
                message: msg,
                type: 'success'
            })
        },
        editCourse(id,type){
            if(type==1){
                this.$router.push({name: 'editTheoryCourse',params: {courseId: id,courseType:type}})
            }else{
                this.$router.push({name: 'editImageCourse',params: {courseId: id,courseType:type}})
            }
        },
        toggleIsShow (val) {
            this.isShow = val
            this.src = null
        },
        courseIsExit(val) {
            this.isPreviewCourse = val
        },
        previewCourse(data) {
            let {type, id} = data
            let that = this
            switch (type) {
                case 1:
                    this.showTheory(id)
                    break
                case 3:
                    that.showImg(id,'CT')
                    break
                case 4:
                    that.showImg(id)
                    break;
                default:
            }
        },
        showTheory(id) {
            this.courseID = id
            this.isPreviewCourse = !this.isPreviewCourse
            this.$refs.theoryCourse.fullScreen()
        },
        showImg(id, type='DR') {
            this.isShow = !this.isShow
            if (type === 'DR') {
                this.src = `${api.imagePanoramicHost}/drCourseDetail?courseId=${id}&lang=${this.$i18n.locale}`
                // this.src = `/static/3D/DR_base.html?type=COURSE_PREVIEW&courseID=${id}`
            } else {
                this.src = `${api.imagePanoramicHost}/ctCourseDetail?courseId=${id}&lang=${this.$i18n.locale}`
                // this.src = `/static/3D/CT_base.html?type=COURSE_PREVIEW&courseID=${id}`
            }
            this.$refs.nstswrap.fullScreen()
        },
        typeBg(type){
            let typeColor=''
            switch (type){
                case 1:
                    typeColor='theory';
                    break;
                case 3:
                    typeColor='ct';
                    break;
                case 4:
                    typeColor='dr';
                    break;
                default:
                    typeColor=''
            }
            return typeColor
        }

    },
    components: {
        selectMultiple,
        selectMultiKnowledge,
        FullScreen,
        CoursePreview
    }

}
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';
    .type-bg{
        display: inline-block;
        width: 80px;
        border-radius: 1px;
        color: #fff;
        &.theory{
            background-color: #6a7881;
        }
        &.ct{
            background-color: #0396a6;
        }
        &.dr{
            background-color: #f4516c;
        }
    }
</style>


